import { Box, makeStyles, ButtonBase, Drawer, TableBody, TableRow, TableCell, Table } from '@material-ui/core';
import { ArrowLeftIcon, FemaleIcon, MaleIcon } from '../../../../components/Icon';
import Text from '../../../../components/Text';
import { Triangle } from '../../components/Triangle';
import { initValue } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    top: '4.375rem !important',
    left: '6.25rem !important',
    '& .MuiBackdrop-root': {
      top: '4.375rem !important',
      left: '6.25rem !important',
    },
  },
  paper: {
    top: '4.375rem !important',
  },
  backBtn: {
    color: '#538FFF',
    gap: '1rem',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
  },
  backIcon: {
    fontSize: '1.25rem',
    color: '#538FFF',
  },
  femaleIcon: {
    fontSize: '1.25rem',
    color: '#FF8181',
  },
  maleIcon: {
    fontSize: '1.25rem',
    color: '#538FFF',
  },
  table: {
    borderCollapse: 'unset',
    '& .MuiTableCell-body': {
      padding: 'unset',
      borderBottom: 'unset',
    },
  },
}));

const InProgress = ({ open, handleBack, admSpecStatic }) => {
  const classes = useStyles();

  return (
    <Drawer classes={{ root: classes.root, paper: classes.paper }} anchor="right" open={open}>
      <Box display="flex" flexDirection="column" width="44.375rem" height="100%">
        <Box height="4.375rem" display="flex" alignItems="center" pl="1.87rem" boxShadow="0px 1px 0px 0px #E4E7EB">
          <ButtonBase className={classes.backBtn} onClick={handleBack}>
            <ArrowLeftIcon className={classes.backIcon} />
            Back
          </ButtonBase>
        </Box>
        <Box flex="1" p="1.9rem 1.9rem 6rem 1.9rem" display="flex" flexDirection="column">
          <Text color="#001D63" fontSize="1.5rem" fontFamily="NotoSans-Bold">
            Pending & In Progress Cases
          </Text>
          <Box flex="1" mt="1.13rem" p="1.25rem" bgcolor="#F5F5F5" borderRadius="4px">
            <Box display="flex" gridGap="1.25rem">
              <Table className={classes.table}>
                <TableBody>
                  {admSpecStatic.map((item) => (
                    <TableRow key={`${initValue(item.specialtyCode, '')} ${initValue(item.subSpecialtyCode, '')}`}>
                      <TableCell>
                        <Text color="#2E4469" fontSize="1.25rem" fontFamily="NotoSans-Bold" lineHeight="1.7rem">
                          {`${initValue(item.specialtyCode, '')} ${initValue(item.subSpecialtyCode, '')}`}
                        </Text>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center" gridGap="0.25rem" height="1.7rem">
                          <MaleIcon className={classes.maleIcon} />
                          <Text color="#538FFF">{`: ${item.maleCount}`}</Text>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center" gridGap="0.25rem" height="1.7rem">
                          <FemaleIcon className={classes.femaleIcon} />
                          <Text color="#FF8181">{`: ${item.femaleCount}`}</Text>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center" height="1.7rem">
                          <Triangle number={1} color="#951B07" value={item.priority1} />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center" height="1.7rem" gridGap="0.25rem">
                          <Text color="#2e4469">Total:</Text>
                          <Text>{item.total}</Text>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default InProgress;
